import AccessRouter, { VIEWS as AccessViews } from '@/components/modules/users/access/router'
import AccountingRouter, { VIEWS as AccountingViews } from '@/components/modules/users/accounting/router'
import StaffAccessRouter, { VIEWS as StaffAccessViews } from '@/components/modules/users/_access/staff/router'
import CustomerAccessRouter, { VIEWS as CustomerAccessViews } from '@/components/modules/users/_access/customer/router'
import SuppliersAccessRouter, { VIEWS as SuppliersAccessViews } from '@/components/modules/users/_access/suppliers/router'
import ActivityLogRouter, { VIEWS as ActivityLogViews } from '@/components/modules/users/activity-log/router'
import BcraRouter, { VIEWS as BcraViews } from '@/components/modules/users/bcra/router'
import BitlyRouter, { VIEWS as BitlyViews } from '@/components/modules/users/bitly/router'
import BudgetsRouter, { VIEWS as BudgetsViews } from '@/components/modules/users/budgets/router'
import ContentsRouter, { VIEWS as ContentsViews } from '@/components/modules/users/contents/router'
import CostsRouter, { VIEWS as CostsViews } from '@/components/modules/users/costs/router'
import CoursesRouter, { VIEWS as CoursesViews } from '@/components/modules/users/courses/router'
import DepositsRouter, { VIEWS as DepositsViews } from '@/components/modules/users/deposits/router'
import EmailMarketingRouter, { VIEWS as EmailMarketingViews } from '@/components/modules/users/email-marketing/router'
import EmployeeRouter, { VIEWS as EmployeeViews } from '@/components/modules/users/employee/router'
import FinancesRouter, { VIEWS as FinancesViews } from '@/components/modules/users/finances/router'
import FormsRouter, { VIEWS as FormsViews } from '@/components/modules/users/forms/router'
import GoogleAdwordsRouter, { VIEWS as GoogleAdwordsViews } from '@/components/modules/users/google-adwords/router'
import InstancesRouter, { VIEWS as InstancesViews } from '@/components/modules/users/instances/router'
import MessagesRouter, { VIEWS as MessagesViews } from '@/components/modules/users/messages/router'
import NotificationsRouter, { VIEWS as NotificationsViews } from '@/components/modules/users/notifications/router'
import OrdersRouter, { VIEWS as OrdersViews } from '@/components/modules/users/orders/router'
import PaymentsRouter, { VIEWS as PaymentsViews } from '@/components/modules/users/payments/router'
import PaymentsErpRouter, { VIEWS as PaymentsErpViews } from '@/components/modules/users/payments-erp/router'
import PhpRouter, { VIEWS as PhpViews } from '@/components/modules/users/php/router'
import PricesRouter, { VIEWS as PricesViews } from '@/components/modules/users/prices/router'
import ProductsRouter, { VIEWS as ProductsViews } from '@/components/modules/users/products/router'
import ProjectsRouter, { VIEWS as ProjectsViews } from '@/components/modules/users/projects/router'
import PurchaseRouter, { VIEWS as PurchaseViews } from '@/components/modules/users/purchase/router'
import PurchaseOrdersRouter, { VIEWS as PurchaseOrdersViews } from '@/components/modules/users/purchase-orders/router'
import PurchaseRemitsRouter, { VIEWS as PurchaseRemitsViews } from '@/components/modules/users/purchase-remits/router'
import ReceiptsErpRouter, { VIEWS as ReceiptsErpViews } from '@/components/modules/users/receipts-erp/router'
import RemindersRouter, { VIEWS as RemindersViews } from '@/components/modules/users/reminders/router'
import RemitsRouter, { VIEWS as RemitsViews } from '@/components/modules/users/remits/router'
import ReportsRouter, { VIEWS as ReportsViews } from '@/components/modules/users/reports/router'
import ReportsAuditRouter, { VIEWS as ReportsAuditViews } from '@/components/modules/users/reports-audit/router'
import ReportsGeneralRouter, { VIEWS as ReportsGeneralViews } from '@/components/modules/users/reports-general/router'
import ReportsMarketingRouter, { VIEWS as ReportsMarketingViews } from '@/components/modules/users/reports-marketing/router'
import ReportsNewsRouter, { VIEWS as ReportsNewsViews } from '@/components/modules/users/reports-news/router'
import ReportsPaymentRouter, { VIEWS as ReportsPaymentViews } from '@/components/modules/users/reports-payment/router'
import ReportsServicesRouter, { VIEWS as ReportsServicesViews } from '@/components/modules/users/reports-services/router'
import ReportsVisitRouter, { VIEWS as ReportsVisitViews } from '@/components/modules/users/reports-visit/router'
import SalesRouter, { VIEWS as SalesViews } from '@/components/modules/users/sales/router'
import SalesFlowRouter, { VIEWS as SalesFlowViews } from '@/components/modules/users/sales-flow/router'
import SellersRouter, { VIEWS as SellersViews } from '@/components/modules/users/sellers/router'
import SensorsRouter, { VIEWS as SensorsViews } from '@/components/modules/users/sensors/router'
import ServicesRouter, { VIEWS as ServicesViews } from '@/components/modules/users/services/router'
import SocialNetworksRouter, { VIEWS as SocialNetworksViews } from '@/components/modules/users/social-networks/router'
import TasksRouter, { VIEWS as TasksViews } from '@/components/modules/users/tasks/router'
import WhatsappMarketingRouter, { VIEWS as WhatsappMarketingViews } from '@/components/modules/users/whatsapp-marketing/router'

/*
 * Registro central reference -> ruta, por módulo.
 *
 * Cada router.js de módulo define su propio VIEWS = { reference: routeName }
 * (mismo reference que usa access.view_reference / m_modules_permissions.
 * reference — no hay sincronización nueva, es la misma clave que ya tiene
 * que coincidir para que los permisos funcionen). Acá se juntan todos esos
 * mapas, indexados por el string `router` del módulo (el mismo que trae
 * permissions.menu) — es la clave module + vista que hace único a cada
 * entrada — y además se enriquecen: cada entrada pasa de ser un string
 * ('RouteName') a un objeto { route, requiresParam }.
 *
 * requiresParam sale de leer el `path` real de esa ruta en el array default
 * que exporta cada router.js (buildModuleRegistry) — no es algo anotado a
 * mano, así que nunca se puede desincronizar de la ruta real: si mañana se
 * agrega o saca un :parametro del path, esto se entera solo. Una vista con
 * requiresParam=true necesita un ID que solo tiene sentido viniendo de otra
 * vista (ej. "detalle de horas de UN empleado") — search.js las excluye de
 * los resultados normales, y quedan disponibles acá para cuando se arme una
 * acción puntual para cada una.
 *
 * Sirve para que el buscador (Ctrl+K, ver command-palette/search.js) pueda
 * resolver permissions.items (module_id + reference) a una ruta navegable,
 * sin tocar el backend.
 *
 * sales-flow es la única clave que no coincide con el nombre de la carpeta:
 * su path real es /st/sales-flow-leads, así que el `router` del módulo es
 * 'sales-flow-leads', no 'sales-flow'.
 */

// ":algo?" es un parámetro opcional (ej. list/:reminderId?) — no cuenta. Si
// después de sacar los opcionales queda algún ":algo", el path exige param.
function hasRequiredParam(path) {
  var withoutOptional = String(path || '').replace(/:[A-Za-z0-9_]+\?/g, '')
  return /:[A-Za-z0-9_]+/.test(withoutOptional)
}

// Busca el path de una ruta por nombre, recorriendo children (mismo array
// que arma cada router.js, con el mismo formato que usa Vue Router).
function findRoutePath(routes, name) {
  for (var i = 0; i < routes.length; i++) {
    var route = routes[i]
    if (route.name === name) return route.path
    if (route.children && route.children.length) {
      var found = findRoutePath(route.children, name)
      if (found !== null) return found
    }
  }
  return null
}

// Convierte { reference: routeName } en { reference: { route, requiresParam,
// personalTo } }.
//
// personalTo (tercer parámetro, opcional): vistas que leen
// Helper.getSeller().id/.name directo, sin chequear antes si el staff
// logueado es vendedor (ver command-palette/search.js).
//
// hiddenParamRefs (cuarto parámetro, opcional): a diferencia de
// requiresParam (que sale solo del path), estas son vistas cuyo componente
// exige un $route.params.X que NO está en el path — se pasa a mano vía
// `params` al navegar (ej. las interfaces PHP, que sí lo arman bien).
// Entrando por una vista suelta del buscador nunca llega ese param, así que
// el componente se auto-redirige apenas carga. No hay forma de derivar esto
// del router.js, hay que revisar el componente y declararlo acá.
function buildModuleRegistry(routerArray, views, personalTo, hiddenParamRefs) {
  personalTo = personalTo || {}
  hiddenParamRefs = hiddenParamRefs || []
  var enriched = {}
  Object.keys(views).forEach(reference => {
    var routeName = views[reference]
    var path = findRoutePath(routerArray, routeName)
    var requiresParam = (path ? hasRequiredParam(path) : false) || hiddenParamRefs.indexOf(reference) !== -1
    enriched[reference] = {
      route: routeName,
      requiresParam: requiresParam,
      personalTo: personalTo[reference] || null,
    }
  })
  return enriched
}

const VIEWS_REGISTRY = {
  access: buildModuleRegistry(AccessRouter, AccessViews),
  accounting: buildModuleRegistry(AccountingRouter, AccountingViews),
  'activity-log': buildModuleRegistry(ActivityLogRouter, ActivityLogViews),
  staff: buildModuleRegistry(StaffAccessRouter, StaffAccessViews),
  customers: buildModuleRegistry(CustomerAccessRouter, CustomerAccessViews),
  suppliers: buildModuleRegistry(SuppliersAccessRouter, SuppliersAccessViews),
  bcra: buildModuleRegistry(BcraRouter, BcraViews),
  bitly: buildModuleRegistry(BitlyRouter, BitlyViews),
  budgets: buildModuleRegistry(BudgetsRouter, BudgetsViews),
  contents: buildModuleRegistry(ContentsRouter, ContentsViews),
  costs: buildModuleRegistry(CostsRouter, CostsViews),
  courses: buildModuleRegistry(CoursesRouter, CoursesViews),
  deposits: buildModuleRegistry(DepositsRouter, DepositsViews),
  'email-marketing': buildModuleRegistry(EmailMarketingRouter, EmailMarketingViews),
  employee: buildModuleRegistry(EmployeeRouter, EmployeeViews),
  finances: buildModuleRegistry(FinancesRouter, FinancesViews),
  forms: buildModuleRegistry(FormsRouter, FormsViews),
  'google-adwords': buildModuleRegistry(GoogleAdwordsRouter, GoogleAdwordsViews),
  instances: buildModuleRegistry(InstancesRouter, InstancesViews),
  messages: buildModuleRegistry(MessagesRouter, MessagesViews),
  notifications: buildModuleRegistry(NotificationsRouter, NotificationsViews),
  orders: buildModuleRegistry(OrdersRouter, OrdersViews, { crudOrdersSeller: 'seller' }),
  payments: buildModuleRegistry(PaymentsRouter, PaymentsViews),
  'payments-erp': buildModuleRegistry(PaymentsErpRouter, PaymentsErpViews),
  php: buildModuleRegistry(PhpRouter, PhpViews, null, ['crudPHPCode', 'viewPHPCustom']),
  prices: buildModuleRegistry(PricesRouter, PricesViews),
  products: buildModuleRegistry(ProductsRouter, ProductsViews),
  projects: buildModuleRegistry(ProjectsRouter, ProjectsViews),
  purchase: buildModuleRegistry(PurchaseRouter, PurchaseViews),
  'purchase-orders': buildModuleRegistry(PurchaseOrdersRouter, PurchaseOrdersViews),
  'purchase-remits': buildModuleRegistry(PurchaseRemitsRouter, PurchaseRemitsViews),
  'receipts-erp': buildModuleRegistry(ReceiptsErpRouter, ReceiptsErpViews),
  reminders: buildModuleRegistry(RemindersRouter, RemindersViews),
  remits: buildModuleRegistry(RemitsRouter, RemitsViews),
  reports: buildModuleRegistry(ReportsRouter, ReportsViews),
  'reports-audit': buildModuleRegistry(ReportsAuditRouter, ReportsAuditViews),
  'reports-general': buildModuleRegistry(ReportsGeneralRouter, ReportsGeneralViews, { crudReportSeller: 'seller' }),
  'reports-marketing': buildModuleRegistry(ReportsMarketingRouter, ReportsMarketingViews),
  'reports-news': buildModuleRegistry(ReportsNewsRouter, ReportsNewsViews, { crudReportSeller: 'seller' }),
  'reports-payment': buildModuleRegistry(ReportsPaymentRouter, ReportsPaymentViews, { crudReportSeller: 'seller', crudSurrenderSeller: 'seller' }),
  'reports-services': buildModuleRegistry(ReportsServicesRouter, ReportsServicesViews),
  'reports-visit': buildModuleRegistry(ReportsVisitRouter, ReportsVisitViews, { crudReportSeller: 'seller', queryAnalysisSeller: 'seller' }),
  sales: buildModuleRegistry(SalesRouter, SalesViews),
  'sales-flow-leads': buildModuleRegistry(SalesFlowRouter, SalesFlowViews, { crudLeadsSellers: 'seller' }),
  sellers: buildModuleRegistry(SellersRouter, SellersViews, { listCalendarSellers: 'seller', listCustomersSellers: 'seller' }),
  sensors: buildModuleRegistry(SensorsRouter, SensorsViews),
  services: buildModuleRegistry(ServicesRouter, ServicesViews),
  'social-networks': buildModuleRegistry(SocialNetworksRouter, SocialNetworksViews),
  tasks: buildModuleRegistry(TasksRouter, TasksViews),
  'whatsapp-marketing': buildModuleRegistry(WhatsappMarketingRouter, WhatsappMarketingViews),
}

export default VIEWS_REGISTRY
